export default __webpack_public_path__ + "static/media/after-noon.42e1dbd9.svg";